import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Field from '../../../../../../../components/Form/Field'

import { ROAS_AVERAGE_FLOOR, TARGET_COST_CAP } from '../../../../../../Multiplatform/LineItemForms/fields'
import {
  campaignOptimizeObjectiveLabels,
  COST_CAP,
  MANUAL,
  MINIMUM_ROAS
} from '../../../../../../../constants/campaigns'

import { selectedFacebookAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import useStyles from '../../../../../../../styles/common/drawerForms'

const TargetCostCapContent = ({ formik, campaignBiddingType, campaignObjective }) => {
  const classes = useStyles()

  const { t } = useTranslation()

  const { currency_symbol } = useSelector(selectedFacebookAdAccountSelector)

  const optimizeObjectiveLabel = campaignOptimizeObjectiveLabels[campaignObjective]

  if (campaignBiddingType === MANUAL) {
    return (
      <div className={classes.subSection}>
        <h4 className={classes.sectionTitle}>{t('Average Cost Goal')}</h4>
        <p>
          {t(
            `Set a maximum cost per ${optimizeObjectiveLabel}. The average cost per conversion will be less than this.`
          )}
        </p>
        <p>{t('If this is set too low, your campaign delivery will be limited.')}</p>
        <Field
          type="number"
          formik={formik}
          name={TARGET_COST_CAP}
          placeholder={t('Average Cost Goal')}
          symbol={currency_symbol}
          autoComplete="off"
        />
      </div>
    )
  }

  if (campaignBiddingType === COST_CAP) {
    return (
      <div className={classes.subSection}>
        <h4 className={classes.sectionTitle}>{t('Bid Cap')}</h4>
        <p>
          {t(
            `Set an average cost per ${optimizeObjectiveLabel} goal. Some conversions will cost less, some will cost more, but the average will be approximately this goal.`
          )}
        </p>
        <p>{t('If this is set too low, your campaign delivery will be limited.')}</p>
        <Field
          type="number"
          formik={formik}
          name={TARGET_COST_CAP}
          placeholder={t('Bid Cap')}
          symbol={currency_symbol}
          autoComplete="off"
        />
      </div>
    )
  }

  if (campaignBiddingType === MINIMUM_ROAS) {
    return (
      <div className={classes.subSection}>
        <h4 className={classes.sectionTitle}>{t('Minimum ROAS')}</h4>
        <p>{t('Set a minimum ROAS for each ad set (conversion value / spend).')}</p>
        <p>
          {t(
            `For example, if for every ${currency_symbol}1 you spend on ads, you need at least ${currency_symbol}2.50 in revenue then your minimum ROAS is 2.5`
          )}
        </p>
        <Field
          type="number"
          formik={formik}
          name={ROAS_AVERAGE_FLOOR}
          placeholder={t('Minimum ROAS')}
          autoComplete="off"
        />
      </div>
    )
  }

  return null
}

export default TargetCostCapContent
